<template>
  <div class="logo">
    <svg
      width="83"
      height="58"
      viewBox="0 0 83 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_di)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58.3953 12.7173H24.9153V38.1558H25.1198C24.9852 38.3883 24.9153 38.6266 24.9153 38.8694C24.9153 41.3835 32.41 43.4216 41.6553 43.4216C50.9005 43.4216 58.3953 41.3835 58.3953 38.8694C58.3953 38.6266 58.3254 38.3883 58.1908 38.1558H58.3953V12.7173Z"
          fill="url(#paint0_linear)"
        />
      </g>
      <g opacity="0.55864" filter="url(#filter1_f)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M58 20H25L28.1194 30H29.251C28.4489 30.4546 28 30.9632 28 31.5C28 33.433 33.8203 35 41 35C48.1797 35 54 33.433 54 31.5C54 30.9632 53.5511 30.4546 52.749 30H53.6678L58 20Z"
          fill="#1D2E7F"
        />
      </g>
      <g filter="url(#filter2_d)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.4351 18.8159V31.4583H17.2751V18.8159H19.4351Z"
          fill="#0D70EB"
        />
      </g>
      <g filter="url(#filter3_dii)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.4303 21.8315L9.71997 17.2731L41.433 5.16016L73.9686 18.4393L40.3872 31.5718L19.4303 21.7924V21.8315Z"
          fill="url(#paint1_linear)"
        />
      </g>
      <g filter="url(#filter4_di)">
        <path
          d="M53.2186 3.23682L56.4496 6.10439L41.9545 22.4366L31.801 15.7557L34.1756 12.1469L41.2052 16.7722L53.2186 3.23682Z"
          fill="#08CE97"
        />
      </g>
      <defs>
        <filter
          id="filter0_di"
          x="14.9153"
          y="6.71729"
          width="53.48"
          height="50.7043"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.00784314 0 0 0 0 0.427451 0 0 0 0 0.929412 0 0 0 0.571214 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.396307 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
        </filter>
        <filter
          id="filter1_f"
          x="19.5634"
          y="14.5634"
          width="43.8731"
          height="25.8731"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.71828"
            result="effect1_foregroundBlur"
          />
        </filter>
        <filter
          id="filter2_d"
          x="8.27515"
          y="13.8159"
          width="20.16"
          height="30.6424"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.193115 0 0 0 0 0.256549 0 0 0 0 0.572743 0 0 0 0.33184 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_dii"
          x="0.719971"
          y="0.160156"
          width="82.2486"
          height="44.4116"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.193115 0 0 0 0 0.256549 0 0 0 0 0.572743 0 0 0 0.33184 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.966502 0 0 0 0 0.972099 0 0 0 0 1 0 0 0 0.311544 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.309004 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow"
            result="effect3_innerShadow"
          />
        </filter>
        <filter
          id="filter4_di"
          x="26.801"
          y="3.23682"
          width="32.6486"
          height="27.1998"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="-1" dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.391581 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0220492 0 0 0 0 0.56584 0 0 0 0 0.431674 0 0 0 0.632403 0"
          />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="21.0518"
          y1="47.0872"
          x2="53.3156"
          y2="55.4288"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0275FF" />
          <stop offset="1" stop-color="#0057BF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="9.71997"
          y1="31.2378"
          x2="72.3433"
          y2="31.2378"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0275FF" />
          <stop offset="1" stop-color="#0059C4" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 75px;
  background: #ffffff;
  box-shadow: 0px 22px 34px rgba(174, 181, 190, 0.0936954);
  border-radius: 12px;
}
</style>
